"use client";

import { c as _c } from "react/compiler-runtime";
import CenteredArea from "@/components/layout/centered-area";
import { Button } from "@/components/ui/button";
import { cn } from "@/utils/helpers";
import parse from "html-react-parser";
import { ChevronDown } from "lucide-react";
import { useState } from "react";
type DescriptionSectionProps = {
  descriptionContent: string;
};
export default function DescriptionSection(t0) {
  const $ = _c(3);
  const {
    descriptionContent
  } = t0;
  const [isExpanded, setIsExpanded] = useState(false);
  let t1;
  if ($[0] !== descriptionContent || $[1] !== isExpanded) {
    t1 = <div className="mt-12 px-2">{descriptionContent ? <><div className="relative"><div className={cn("prose max-w-none dark:prose-invert", isExpanded ? "" : "line-clamp-[12]")}>{parse(descriptionContent)}</div><div className={cn("absolute inset-0 h-full w-full bg-gradient-to-b from-transparent via-transparent to-background/80", isExpanded ? "hidden" : "block")} /></div><Button variant="outline" className="mt-8 flex w-full items-center gap-2" onClick={() => setIsExpanded(!isExpanded)}><span>{isExpanded ? "Show less" : "Show more"}</span><ChevronDown size={16} className={cn("transition", isExpanded ? "rotate-180" : null)} /></Button></> : <CenteredArea className="border"><span className="text-sm">No description added</span></CenteredArea>}</div>;
    $[0] = descriptionContent;
    $[1] = isExpanded;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
}